import { gql, useQuery } from '@apollo/client';
import { Box, Button, Paper, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Account } from 'types/Account';
import { Timeline as TimelineType } from 'types/timeline.types';
import calendar from 'dayjs/plugin/calendar';
import fragments from 'services/fragments';
import { Link } from 'react-router-dom';
import TimelineList from 'components/TimelineList';

dayjs.extend(calendar);

const TIMELINE = gql`
  ${fragments.Timeline}
  query TimelineRecent(
    $isCloud: Boolean!
    $accountId: Int
    $userId: Int
    $email: String
    $hasPermissionToViewSO: Boolean
    $hasPermissionToViewOpenSO: Boolean
    $hasPermissionToViewOccurrenceLogs: Boolean
    $notificationMoment: String
    $timezone: Int
    $masterCompanyId: Int
    $accountType: Int
  ) {
    TimelineRecent(
      isCloud: $isCloud
      accountId: $accountId
      userId: $userId
      email: $email
      hasPermissionToViewSO: $hasPermissionToViewSO
      hasPermissionToViewOpenSO: $hasPermissionToViewOpenSO
      hasPermissionToViewOccurrenceLogs: $hasPermissionToViewOccurrenceLogs
      notificationMoment: $notificationMoment
      timezone: $timezone
      masterCompanyId: $masterCompanyId
      accountType: $accountType
    ) {
      ...TimelineProperties
    }
  }
`;

function Timeline({ account }: { account: Account }) {
  const { t } = useTranslation('_common');

  const { data, error, loading } = useQuery<{ TimelineRecent: TimelineType[] }>(TIMELINE, {
    variables: {
      ...account,
      accountId: account.id,
    },
  });

  if (error) {
    throw error;
  }

  const haveData = data && (data.TimelineRecent?.length || 0) > 0;
  const isEmpty = !loading && !haveData;

  return (
    <Paper
      variant="outlined"
      sx={{
        pt: 2,
        // height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        flex: '1 1 auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 2,
          flex: '0 0 auto',
        }}
      >
        <Typography variant="h6">{t('timeline')}</Typography>
        <Button component={Link} to="/events">
          {t('see_all')}
        </Button>
      </Box>
      {loading && <TimelineList.Loading />}
      {haveData && <TimelineList.Content events={data.TimelineRecent} />}
      {isEmpty && <TimelineList.Empty />}
    </Paper>
  );
}

export default Timeline;
